import { BannerItem } from "fetchers/banner";

export const duplicateBanner = (banner: BannerItem): BannerItem => {
  const clone = { ...banner };
  clone.id = undefined;
  return clone;
};
